import { Link } from "react-router-dom";
import { CherrySwirl, CameraIcon, PolaroidIcon } from "@/components/Brand";

export default function Footer({ onBook }) {
  return (
    <footer id="contacto" className="relative bg-cerenza-cherry text-cerenza-creamlight overflow-hidden" data-testid="footer">
      {/* Decorative scattered icons */}
      <div className="pointer-events-none absolute inset-0 opacity-15">
        <CameraIcon color="#ffffd7" className="absolute top-12 left-[8%] w-14 h-14 rotate-[-12deg]" />
        <PolaroidIcon color="#ffffd7" className="absolute top-24 right-[10%] w-16 h-16 rotate-[8deg]" />
        <CherrySwirl color="#ffffd7" className="absolute bottom-32 left-[18%] w-14 h-14 rotate-[14deg]" />
        <CameraIcon color="#ffffd7" className="absolute bottom-20 right-[22%] w-12 h-12 rotate-[20deg]" />
      </div>

      <div className="relative max-w-[1320px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-6">
            <p className="font-script text-3xl text-cerenza-pink">¡Hola, familia!</p>
            <h3 className="font-display text-5xl md:text-7xl mt-3 leading-[0.98] text-balance">
              Algunos momentos merecen <em className="not-italic underline decoration-cerenza-pink decoration-4 underline-offset-8">quedarse</em> para siempre.
            </h3>
            <button
              data-testid="footer-book-btn"
              onClick={onBook}
              className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-cerenza-cream text-cerenza-cherry rounded-full font-semibold uppercase tracking-[0.14em] text-xs hover:bg-cerenza-pink transition-all duration-300 hover:-translate-y-0.5"
            >
              Reserva tu experiencia →
            </button>
          </div>

          <div className="md:col-span-3 text-center md:text-left">
            <p className="uppercase text-[11px] tracking-[0.22em] font-semibold text-cerenza-pink">Estudio</p>
            <ul className="mt-5 space-y-2.5 text-base text-cerenza-creamlight/85">
              <li>Citas con reserva previa</li>
              <li>Miércoles — Domingo</li>
              <li>
                <a href="mailto:cerenzafamilyphotoroom@gmail.com" className="hover:text-cerenza-pink transition-colors break-words text-[15px]">
                  cerenzafamilyphotoroom@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3 text-center md:text-left">
            <p className="uppercase text-[11px] tracking-[0.22em] font-semibold text-cerenza-pink">Síguenos</p>
            <ul className="mt-5 space-y-2.5 text-base">
              <li>
                <a
                  href="https://www.instagram.com/cerenza_familyphotoroom"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                  className="inline-flex items-center gap-2 hover:text-cerenza-pink transition-colors break-all"
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                  @cerenza_familyphotoroom
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-cerenza-pink/30 flex flex-col md:flex-row gap-3 justify-between items-start md:items-center text-xs text-cerenza-creamlight/70">
          <p>© {new Date().getFullYear()} Cerenza — Family Photo Room. Hecho con cariño 🍒</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="uppercase tracking-[0.22em] hover:text-cerenza-pink transition-colors">
            Acceso estudio
          </Link>
        </div>
      </div>
    </footer>
  );
}
